import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconChartPie = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.25 1.25C13.8358 1.25 13.5 1.58579 13.5 2V9.75C13.5 10.1642 13.8358 10.5 14.25 10.5H22C22.4142 10.5 22.75 10.1642 22.75 9.75C22.75 5.05443 18.9456 1.25 14.25 1.25ZM15 9V2.78967C18.2678 3.13746 20.8625 5.73218 21.2103 9H15Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.5 3.25C6.39011 3.25 2.25 7.39011 2.25 12.5C2.25 17.6099 6.39011 21.75 11.5 21.75C16.6099 21.75 20.75 17.6099 20.75 12.5C20.75 12.0858 20.4142 11.75 20 11.75H12.25V4C12.25 3.58579 11.9142 3.25 11.5 3.25ZM3.75 12.5C3.75 8.47156 6.82069 5.1628 10.75 4.78579V12.5C10.75 12.9142 11.0858 13.25 11.5 13.25H19.2142C18.8372 17.1793 15.5284 20.25 11.5 20.25C7.21854 20.25 3.75 16.7815 3.75 12.5Z",
		fill: "currentColor"
	})]
});
export { SvgIconChartPie as ReactComponent };
